import {Enum} from './enun';

export const reportStatus = new Enum({
  unavailable: 0,
  updated: 1,
  outdated: 2,
  complete: 3,
  incomplete: 4
});

export const reportStatusOrder = new Enum({
  complete: 1,
  updated: 2,
  incomplete: 3,
  outdated: 4,
  unavailable: 5
});

export const reportStatusColor = new Enum({
  red: 0,
  green: 1,
  orange: 2
});
